import { render } from "./ViewVenueModal.vue?vue&type=template&id=0bb28a51&scoped=true"
import script from "./ViewVenueModal.vue?vue&type=script&lang=js"
export * from "./ViewVenueModal.vue?vue&type=script&lang=js"

import "./ViewVenueModal.vue?vue&type=style&index=0&id=0bb28a51&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb28a51"]])

export default __exports__